import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import ProductData from '../data/products.json';
const { productsData } = { ...ProductData };
import FirmwareData from '../data/firmware.json';
const { firmwareData } = { ...FirmwareData };
import Table from '../components/table/table';
import { searchProductData, updateProductDCL } from '../api/productsApi';
import { createFirmwareData, fetchFirmwareData, uploadFirmware, updateFirmwareData, createPai, fetchPAI_UsermanualData, uploadPAI, deletePaiData, createUserManual, uploadUserManual, deleteUserManualData, publishFirmwareDCL, updateFirmwareDCL, deleteFirmwareDCL, deleteFirmwareData, removeUploadedDoc, downloadDoc, downloadFirmwareDoc } from '../api/firmwareApi';
import DisplayContent from '../modals/displayModal/displayContent';
import DropDown from '../components/common/Select/select';
import DisplayModal from '../modals/displayModal/displayModal';
import generateFileUploadDetails from '../integration/generateFileDetails';
import createFileRecord from '../integration/createFileRecordData';
import LinearProgress from '@mui/material/LinearProgress';
import { parseReqBodyNumber } from '../genericFunctions/parseReqBody';
import { NullUndefinedCheck } from '../genericFunctions/nullUndefinedCheck';
import { DownloadDocument } from '../functions/downloadDocuments';
import { decode } from '../helpers/decode_env';
import handle_toast  from '../genericFunctions/toast_Handler';

const ProductInformation = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const searchParams = new URLSearchParams(location.search)
    const [vid, setVid] = useState(searchParams.get('vid'));
    const { id } = useParams();
    const userDetails = sessionStorage.getItem('userDetails') ? JSON.parse(sessionStorage.getItem('userDetails')) : {};
    const dropDownData = sessionStorage.getItem('dropDownData') ? JSON.parse(sessionStorage.getItem('dropDownData')) : {};
    const dataCopy = JSON.parse(JSON.stringify(productsData.productModalData))
    const [valueData, setData] = useState([]);
    const [formattedData, setFormattedData] = useState({});
    const [firmwareValData, setFirmwareData] = useState([]);
    const [documentValdata, setDocsData] = useState([]);
    const [modalVisible, setModalVisible] = useState(false);
    const locationUpload = location.state?.Upload ?? null;
    const [attachType, setAttachType] = useState(locationUpload);
    const [modalData, setModalData] = useState(
      locationUpload && locationUpload.includes('Firmware')
        ? firmwareData.firmwareModalData
        : locationUpload && locationUpload.includes('User Manual')
        ? firmwareData.userManualModalData
        : firmwareData.paiModalData
    );
    const [loading, setLoading] = useState(false);
    const [firmwareAccessData, setFirmwareAccessData] = useState(null);
    const [documentAccessData, setDocumentAccessData] = useState(null);
    const [isUploadAllowed, setIsUploadAllowed] = useState(true);
    const [scrollableHeight, setMaxScrollableHeight] = useState(0);
    
    const  calcTableHeight = () => {
      const windowHeight = window.innerHeight;
      const header = 150;
      const availableHeight  = windowHeight - header;
      setMaxScrollableHeight(availableHeight > 200 ? availableHeight : 0);
    }
    
    useEffect(() => {
      calcTableHeight();
      return () => {
        window.removeEventListener('resize', calcTableHeight);
      }
    }, [])

    useEffect(() => {
      const accesdata = sessionStorage.getItem('accessData') ? JSON.parse(sessionStorage.getItem('accessData')) : {};
      setFirmwareAccessData(accesdata['Product Firmware'])
      setDocumentAccessData(accesdata['Product User Manual'])
      if(!userDetails.isAdmin){
        if (accesdata['Product Firmware'] && accesdata['Product User Manual'] && accesdata['Product Firmware'].grantCreate === false && accesdata['Product User Manual'].grantCreate === false) {
          setIsUploadAllowed(false);
        }
      }

      if (Object.keys(valueData).length == 0) {
          formatData();
          fetchProducts();
          if (attachType && modalData) toggleModal();
      }
    }, [valueData])

    const formatData = () => {
      dataCopy.childrenItems.map((obj) => {
          obj.disabled = true;
      })
      const formatdata = dataCopy.childrenItems.reduce((acc, item) => {
          if (!acc[item.section]) acc[item.section] = [];
          acc[item.section].push(item);
          return acc;
      }, {})
      setFormattedData(formatdata);
    }

    const fetchProducts = async () => {
      setLoading(true);
      try {
          const resp = await searchProductData({ 'matterProductId': id });
          const valData = resp?.data?.data[0]
          if(valData['vid'] == '4190') valData['vid_name'] = 'Schneider Electric';
          else if(valData['vid'] == '5481') valData['vid_name'] = 'Feller';
          setVid(valData['vid'])
          setData(valData)
          if(valData && !dropDownData['ProductList'].some(product => product.name == valData.matterProductId)){
            setIsUploadAllowed(false)
          }
          fetchFirmware();
          fetchDocuments();
          setLoading(false)
          handle_toast({message: `Product fetched`, status: 'success'})
      }
      catch (error) {
        setLoading(false)
        handle_toast(error)
      }
    }

    const fetchFirmware = async () => {
      setLoading(true);
      try {
        const resp = await fetchFirmwareData({ 'productId': id });
        setFirmwareData(resp?.data?.data)
        setLoading(false)
        handle_toast({message: `Firmware fetched`, status: 'success'})
      }
      catch (error) {
        setLoading(false)
        handle_toast(error)
      }
    }

    const fetchDocuments = async () => {
      setLoading(true);
      try {
        const resp = await fetchPAI_UsermanualData({ 'productId': id });
        setDocsData(resp?.data?.data)
        setLoading(false)
        handle_toast({message: `Documents fetched`, status: 'success'})
      }
      catch (error) {
        setLoading(false)
        handle_toast(error)
      }
    }

    const toggleModal = () => {
        setModalVisible(!modalVisible);
    }

    const handleChange = (value) => {
      setAttachType(value);
      setModalData(value?.includes('Firmware') ? firmwareData.firmwareModalData : value?.includes('User Manual') ? firmwareData.userManualModalData : firmwareData.paiModalData);
      toggleModal();
    }

    const handleUpload = async (formValue) => {
      setLoading(true);
      formValue['productId'] = id;
      const formData = generateFileUploadDetails(attachType, formValue)
      // ****************Firmware Upload****************
      if(attachType?.includes('Firmware')){
          const resp = await uploadFirmware(formData)
          if(resp){
            let dclFirmwareResp, firmResp = null;
            formValue['vid'] = vid;
            formValue['otaUrl'] = resp?.data?.fileUrl
            formValue['publish'] = 'No';
            const recordData = createFileRecord(formValue, resp?.data, attachType, 'Test');
            const completeForm = { ...formValue, ...recordData }
            try {
                dclFirmwareResp = await publishFirmwareDCL(parseReqBodyNumber(completeForm), 'test')
                firmResp = await createFirmwareData(completeForm)
                if(dclFirmwareResp && firmResp){
                    handle_toast({message: `Firmware File: ${firmResp.data.data.fileName} Uploaded, Published to DCL`, details: `https://testnet.iotledger.io/models`, status: 'success'})
                    fetchFirmware()
                    setLoading(false);
                }
            }
            catch (error) {
              handle_toast(error)
              if(NullUndefinedCheck(firmResp)){
                if(!NullUndefinedCheck(dclFirmwareResp)) {
                  await deleteFirmwareDCL(parseReqBodyNumber(completeForm), 'test')                      
                  await removeUploadedDoc(parseReqBodyNumber(completeForm))
                }
                fetchFirmware();
                setLoading(false)
              }
            }
          }
          else{
            setLoading(false)
            handle_toast({message: 'Upload Failed', status: 'error'})
          }
      }
      // ****************Firmware Upload Ends****************
      // ****************User Manual Doc Upload****************
      if(attachType?.includes('User Manual')){
          const resp = await uploadUserManual(formData);
          if(resp){
            const productRecord = JSON.parse(JSON.stringify(valueData));
            let dclMainResp, dclTestResp, userManualResp = null;
            formValue['vid'] = vid;
            const recordData = createFileRecord(formValue, resp?.data, attachType);
            const completeForm = { ...formValue, ...recordData }
            try{
                productRecord['userManualUrl'] = resp?.data?.fileUrl;                
                if(productRecord.status == 'Published') {
                  dclMainResp = await updateProductDCL(parseReqBodyNumber(productRecord), 'main')
                  dclTestResp = await updateProductDCL(parseReqBodyNumber(productRecord), 'test')
                }
                if(productRecord.status == 'Test') dclTestResp = await updateProductDCL(parseReqBodyNumber(productRecord), 'test')
                userManualResp = await createUserManual(completeForm)
                if(dclMainResp && dclTestResp && userManualResp && productRecord.status == 'Published'){
                  handle_toast({message: `User Manual Created, Published to DCL`, details: `https://webui.dcl.csa-iot.org/models, https://testnet.iotledger.io/models`, status: 'success'})
                  fetchDocuments();
                }
                if(dclTestResp && userManualResp && productRecord.status == 'Test'){
                  handle_toast({message: `User Manual created, Published to DCL`, details: `https://testnet.iotledger.io/models`, status: 'success'})
                  fetchDocuments();
                }
            }
            catch (error) {
              handle_toast(error)
              if(NullUndefinedCheck(userManualResp)){
                if(!NullUndefinedCheck(dclTestResp)) {
                  await updateProductDCL(parseReqBodyNumber(valueData), 'test')                      
                  await removeUploadedDoc(parseReqBodyNumber(completeForm))
                }
                if(!NullUndefinedCheck(dclMainResp)) {
                  await updateProductDCL(parseReqBodyNumber(valueData), 'main')                      
                  await removeUploadedDoc(parseReqBodyNumber(completeForm))
                }
                fetchDocuments();
                setLoading(false)
              }
            }
          }
          else{
            setLoading(false)
            handle_toast({message: 'Upload Failed', status: 'error'})
          }
      }
      // ****************User Manual Doc Upload Ends****************
      // ****************Other Doc Upload****************
      if(!attachType?.includes('Firmware') && !attachType?.includes('User Manual')){
          const resp = await uploadPAI(formData);
          if(resp){
            let paiResp = null
            const recordData = createFileRecord(formValue, resp?.data, attachType);
            const completeForm = { ...formValue, ...recordData }
            try {
                paiResp = await createPai(completeForm)
                if(paiResp){
                    await fetchDocuments()
                    handle_toast({message: `${attachType} Data Saved for File: ${paiResp?.data?.data?.fileName}`, status: 'success'})
                    setLoading(false);
                }
            }
            catch (error) {
              handle_toast(error)
              if(NullUndefinedCheck(paiResp)) removeUploadedDoc(completeForm)
              fetchDocuments();
              handle_toast(error)
              setLoading(false);
            }
          }
          else{
            setLoading(false)
            handle_toast({message: 'Upload Failed', status: 'error'})
          }
      }
    }

    const handleEdit = async (formData) => {
      let dclMainResp, dclTestResp, firmResp = null;
      formData['vid'] = vid;
      formData['productId'] = id;
      try{
        if(formData['publish'] == 'Yes' && formData['status'] == 'Published') {
          dclMainResp = await updateFirmwareDCL(parseReqBodyNumber(formData), 'main')
          dclTestResp = await updateFirmwareDCL(parseReqBodyNumber(formData), 'test')
          firmResp = await updateFirmwareData(parseReqBodyNumber(formData))
          if(dclMainResp && dclTestResp && firmResp){
            handle_toast({message: `Firmware Updated, Updated on DCL`, details: `https://webui.dcl.csa-iot.org/models, https://testnet.iotledger.io/models`, status: 'success'})
            fetchFirmware();
          }
        }
        if(formData['publish'] == 'No') {
          dclTestResp = await updateFirmwareDCL(parseReqBodyNumber(formData), 'test')
          firmResp = await updateFirmwareData(parseReqBodyNumber(formData))
          if(dclTestResp && firmResp){
            handle_toast({message: `Firmware Updated, Updated on DCL`, details: `https://testnet.iotledger.io/models`, status: 'success'})
            fetchFirmware();
          }
        }
        if(formData['publish'] == 'Yes' && formData['status'] == 'Test'){
          dclMainResp = await publishFirmwareDCL(parseReqBodyNumber(formData), 'main')
          if(dclMainResp) formData['status'] = 'Published';
          dclTestResp = await updateFirmwareDCL(parseReqBodyNumber(formData), 'test')
          firmResp = await updateFirmwareData(parseReqBodyNumber(formData))
          if(dclMainResp && dclTestResp && firmResp){
            handle_toast({message: `Firmware Updated, Updated on DCL`, details: `https://webui.dcl.csa-iot.org/models, https://testnet.iotledger.io/models`, status: 'success'})
            fetchFirmware();
          }
        }
      }
      catch (error) {
        handle_toast(error)
        const notUpdatedRecord = firmwareValData.filter(obj => obj.id == formData.id)
        if(NullUndefinedCheck(firmResp)){
          if(!NullUndefinedCheck(dclMainResp)) await updateFirmwareDCL(parseReqBodyNumber(notUpdatedRecord), 'main')
          if(!NullUndefinedCheck(dclTestResp)) await updateFirmwareDCL(parseReqBodyNumber(notUpdatedRecord), 'test')
          fetchFirmware();
          setLoading(false)
        }
      }
    }

    const handleDelete = async (formData) => {
      formData['vid'] = vid;
      const productRecord = JSON.parse(JSON.stringify(valueData));
      if(formData.docType == 'User Manual'){
          setLoading(true)
          let dclMainResp, dclTestResp, productResp = null;
          try{
            productRecord['userManualUrl'] = '';
            if(formData['publish'] == 'Yes') {
              dclMainResp = await updateProductDCL(parseReqBodyNumber(productRecord), 'main')
              dclTestResp = await updateProductDCL(parseReqBodyNumber(productRecord), 'test')
              productResp = await deleteUserManualData(parseReqBodyNumber(formData))
              if(dclMainResp && dclTestResp && productResp){
                handle_toast({message: `Manual deleted, Removed from DCL`, details: `https://webui.dcl.csa-iot.org/models, https://testnet.iotledger.io/models`, status: 'success'})
                fetchDocuments();
              }
            }
            if(formData['publish'] == 'No') {
              dclTestResp = await updateProductDCL(parseReqBodyNumber(productRecord), 'test')
              productResp = await deleteUserManualData(parseReqBodyNumber(formData))
              if(dclTestResp && productResp){
                handle_toast({message: `Manual deleted, Removed from DCL`, details: `https://testnet.iotledger.io/models`, status: 'success'})
                fetchDocuments();
              }
            }
          }
          catch(error){
            handle_toast(error) 
            const az_storage_url = process.env.REACT_APP_BACKEND_AZURE_STORAGE_URL ? decode(process.env.REACT_APP_BACKEND_AZURE_STORAGE_URL) : '';
            const az_container_name = process.env.REACT_APP_BACKEND_AZURE_CONTAINER_NAME ? decode(process.env.REACT_APP_BACKEND_AZURE_CONTAINER_NAME) : '';         
            productRecord['userManualUrl'] = `${az_storage_url}/${az_container_name}/${formData['fileLocationPath']}`;
            if(NullUndefinedCheck(productResp)){
              if(!NullUndefinedCheck(dclMainResp)) await updateProductDCL(parseReqBodyNumber(productRecord), 'main')
              if(!NullUndefinedCheck(dclTestResp)) await updateProductDCL(parseReqBodyNumber(productRecord), 'test')
              fetchDocuments()
              setLoading(false)
            }
          }
      }
      else{
          try {
              const paiResp = await deletePaiData(formData);
              handle_toast({message: `Document Data Deleted for File: ${paiResp.data.deletedPai.fileName}`, status: 'success'})
              if(paiResp.status == 200) {
                fetchDocuments();
              }
          }
          catch (error) {
            handle_toast(error)
            setLoading(false)
          }
      }
    }

    const handleDeleteFirmware = async (formData) => {
      formData['vid'] = vid;
      let dclMainResp, dclTestResp, firmResp = null;
      try{
        if(formData['publish'] == 'Yes') {
          dclMainResp = await deleteFirmwareDCL(parseReqBodyNumber(formData), 'main')
          dclTestResp = await deleteFirmwareDCL(parseReqBodyNumber(formData), 'test')
          firmResp = await deleteFirmwareData(parseReqBodyNumber(formData))
          if(dclMainResp && dclTestResp && firmResp){
            handle_toast({message: `Firmware deleted, Removed from DCL`, details: `https://webui.dcl.csa-iot.org/models, https://testnet.iotledger.io/models`, status: 'success'})
            fetchFirmware();
          }
        }
        if(formData['publish'] == 'No') {
          dclTestResp = await deleteFirmwareDCL(parseReqBodyNumber(formData), 'test')
          firmResp = await deleteFirmwareData(parseReqBodyNumber(formData))
          if(dclTestResp && firmResp){
            handle_toast({message: `Firmware deleted, Removed from DCL`, details: `https://testnet.iotledger.io/models`, status: 'success'})
            fetchFirmware();
          }
        }
      }
      catch (error) {
        handle_toast(error)
        if(NullUndefinedCheck(firmResp)){
          if(!NullUndefinedCheck(dclMainResp)) await updateFirmwareDCL(parseReqBodyNumber(formData), 'main')
          if(!NullUndefinedCheck(dclTestResp)) await updateFirmwareDCL(parseReqBodyNumber(formData), 'test')
          fetchFirmware()
          setLoading(false)
        }
      }
    }

    const handleFirmwareDownload = async (formData) => {
      try{
        const response = await downloadFirmwareDoc(formData);
        DownloadDocument(response, formData);
      }
      catch(error){
        handle_toast(error)
      }
    }

    const handleDocDownload = async (formData) => {
      try{
        const response = await downloadDoc(formData);
        DownloadDocument(response, formData);
      }
      catch(error){
        handle_toast(error)
      }
    }

    return (
        <>
            <div className='componentContainer scrollableView' style={{height: scrollableHeight}}>
                {loading && <LinearProgress />}
                <div className='headingAlign'>
                    <se-icon size="medium" onClick={() => navigate(`/products`)} style={{ cursor: 'pointer' }}>action_previous</se-icon>
                    <span>Product Information</span>
                </div>
                <div className={dataCopy.childrenItems.length > 8 ? 'fullGrid' : 'smallerGrid'} >
                    {
                        Object.keys(valueData).length > 0 && Object.keys(formattedData).length > 0 && Object.entries(formattedData).map(([key, value]) => (
                            <div key={`section` + key} className={!dataCopy.imageModal ? 'secondSection' : 'firstSection'}>
                                {value && <DisplayContent source='modalview' contentData={value} formFields={valueData} page='productInfo' />}
                            </div>
                        ))
                    }
                </div>
                <div>
                    <div className='subNavigationContainer'>
                        <label className='leftAlign' style={{ fontWeight: 'bold', fontSize: '16px' }}>Firmware</label>
                        {isUploadAllowed && <DropDown
                            multiselect={false}
                            ddoptionlist={dropDownData['Firmware Attach']}
                            option='flat'
                            type='attach'
                            placeholder='Attach'
                            onChange={(value) => handleChange(value)} />
                        }
                    </div>
                    <div className='tableContainer'>
                        {
                          firmwareAccessData && <Table columns={firmwareData.firmwareHeaders} access={firmwareAccessData} body={firmwareValData} modalData={firmwareData.firmwareModalData} page='Firmware' onSave={handleEdit} onDelete={handleDeleteFirmware} onDownload={handleFirmwareDownload}/>
                        }
                    </div>
                    <div className='documentTableContainer'>
                        <label className='leftAlign' style={{ fontWeight: 'bold', fontSize: '16px' }}>Other Documents</label>
                        <div className='tableContainer'>
                            {
                              documentAccessData && <Table columns={firmwareData.documentsHeaders} access={documentAccessData} body={documentValdata} modalData={firmwareData.firmwareModalData} page='User Manual / PAI' onSave={handleEdit} onDelete={handleDelete} onDownload={handleDocDownload}/>
                            }
                        </div>
                    </div>
                </div>
                {modalVisible && <DisplayModal toggleModal={toggleModal} data={modalData} source="create" onSave={handleUpload} page={attachType} />}
            </div>
        </>
    )
};
export default ProductInformation;
